import { UNITED_STATES_LIST } from 'client/data/constants/united-states-list';
import { makes } from 'client/data/constants/active-makes';

export const LEASE_DEALS_PATH = '/lease-deals/';
export const LEASE_DEALS_BEST_BODY_TYPE_PATH =
  '/best-:bodyType(suv|sedan|cargo-van|convertible|coupe|crossover|hatchback|minivan|truck|wagon)-lease-deals/';
export const LEASE_DEALS_BEST_ENGINE_TYPE_PATH = '/best-:engineType(diesel|electric|hybrid)-lease-deals/';
export const LEASE_DEALS_BEST_TYPE_PATH = '/best-:edmundsTypeCategories(luxury)-lease-deals/';
export const LEASE_DEALS_MONTHLY_199_PATH = '/car-leasing/monthly-:monthlyPayment(199)-lease-deals.html';
export const LEASE_DEALS_STATE_PATH = `/lease-deals/:state(${UNITED_STATES_LIST.join('|')})`;
export const LEASE_DEALS_MAKE_PATH = `/:make(${makes.join('|')})-lease-deals/`;
export const LEASE_DEALS_MAKE_CITY_STATE_PATH = `/:make(${makes.join('|')})-lease-deals-:locationPartialUrl`;

export const LEASE_DEALS_PATHS = [
  LEASE_DEALS_PATH,
  LEASE_DEALS_STATE_PATH,
  LEASE_DEALS_BEST_BODY_TYPE_PATH,
  LEASE_DEALS_BEST_ENGINE_TYPE_PATH,
  LEASE_DEALS_BEST_TYPE_PATH,
  LEASE_DEALS_MONTHLY_199_PATH,
  LEASE_DEALS_MAKE_PATH,
  LEASE_DEALS_MAKE_CITY_STATE_PATH,
];
